import Component from '../../components/Component';

import query from './query';
import { keys, keysPage } from './keys';
import ListData from '../../components/ListData';

class Summary extends Component {
    constructor(props) {
        super();
        this.query = query(props.page);
    }

    render() {
        const data = this.state.data?.length
            ? this.state.data?.sort((a, b) => b.sum_impressions - a.sum_impressions)?.slice(0, 10)
            : [];

        const dataKeys = this.props.page ? keysPage : keys;
        return (
            <>
                <ListData
                    loading={this.state.loading}
                    header={this.props.header ?? 'Top Categories'}
                    subheader={this.props.subheader ?? '(by relevancy)'}
                    forceRun={this.forceRun}
                    link={`/domain/${this.props.domain_id}/categories`}
                    keys={dataKeys}
                    uniqKey="level"
                    data={data}
                    itemClassName={this.props.page ? 'justify-content-start' : ''}
                    cardClassName={'list-data-full'}
                    customEmptyMessage={this.props.error_message}
                />
            </>
        );
    }
}

export default Summary;
